/* eslint-disable max-len */
import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
// import { UIChart } from 'primeng/chart';
import { LANGUAGES } from 'src/app/conf/languages';
import { AppState } from 'src/app/store/app.reducer';
import * as UserActions from 'src/app/store/user/user.actions';
import { Observable, Subscription } from 'rxjs';
import { User } from 'src/app/model/user';
import { selectUser } from 'src/app/store/user/user.selector';
import { StandardPageLayout } from '../shared/stdlayoutlib/classes.stdlayoutlib';

@Component({
	selector: 'app-public-sw-page-noauth',
	templateUrl: './public-sw-page-noauth.component.html',
})

export class PublicSwPageNoAuthComponent implements OnInit, OnDestroy {
	user$: Observable<User | undefined>;
	userSub: Subscription | undefined;

	guest = true;

	// design
	screenWidth: number;
	screenHeight: number;

	constructor(
		private route: ActivatedRoute,
		private translate: TranslateService,
		private store: Store<AppState>
	) {
		this.initSelectors();
	}

	initSelectors(): void {
		// Store selectors
		this.user$ = this.store.select(selectUser);
	}

	ngOnDestroy(): void {
		this.userSub?.unsubscribe();
	}

	ngOnInit() {
		// this.store.dispatch(NotificationsActions.setTopbarTitleId({
		// 	stringId: 'BUS_PAGE_TITLE'
		// }));
		this.userSub = this.user$?.subscribe(currentUser => {
			if (currentUser !== undefined && currentUser.Email !== undefined && currentUser.Email !== '') {
				this.guest = false;
			}
		});
		const lang = this.route.snapshot.queryParamMap.get('language');
		const langVal = LANGUAGES.find(l => l.code === lang);
		if (langVal !== undefined) {
			this.store.dispatch(UserActions.setCurrentLang({ lang: langVal }));
			if (langVal.code !== this.translate.currentLang && localStorage != null) {
				window.location.reload();
			}
		}

		this.onResize();
	}

	downloadIntercom10Beta() {
		const url = "https://download.cameconnect.net/tools/came_intercom_setup_1.0.0.0-beta.zip"
		window.open(url);
	}

	getReleaseNoteIntercom10Beta(): string {
		const lang = this.translate.currentLang;
		switch (lang) {
			case 'it-IT': {
				return `
				<ul>
					<li><strong>Prima release versione 1.0.0.0</strong></br>
						<ul>
							<li>Compatibilità esclusivamente con sistemi IP360</li>
							<li>Nuova interfaccia utente</li>
							<li>Visualizzazione della struttura impianto in modalità albero o tabellare</li>
							<li>Template guidati per la creazione rapida di impianti</li>
							<li>Importazione di file legacy creati con PCS/XIP</li>
							<li>Calcolo automatico dei limiti di sistema</li>
							<li>Gestione semplificata dei permessi e del controllo accessi</li>
							<li>Rilevamento dispositivi tramite mDNS o scansione di rete</li>
							<li>Sezione Help integrata con documentazione</li>
						</ul>
					</li>
				</ul>
				`;
			}
			default: { // 'en-US'
				return `
				<ul>
					<li><strong>First release version 1.0.0.0</strong></br>
						<ul>
							<li>Compatibility exclusively with IP360 systems</li>
							<li>New user interface</li>
							<li>System structure view in tree or table mode</li>
							<li>Guided templates for quick system creation</li>
							<li>Importing of legacy files created with PCS/XIP</li>
							<li>Automatic calculation of system limits</li>
							<li>Simplified management of permissions and access control</li>
							<li>Device detection via mDNS or network scan</li>
							<li>Integrated Help section with documentation</li>
						</ul>
					</li>
				</ul>
				`;
			}
		}
	}

	downloadUpgrader228() {
		const url = "https://download.cameconnect.net/tools/came_upgrader_2.2.8.zip"
		window.open(url);
	}

	getReleaseNoteUpgrader228(): string {
		const lang = this.translate.currentLang;
		switch (lang) {
			case 'it-IT': {
				return `
					<ul>
						<li><strong>Modifiche rispetto alla versione 2.2.6</strong></br>
							<ul>
								<li>Corretto riconoscimento dei dispositivi con firmware aggiornato al nuovo configuratore web</li>
								<li>Corretta funzionalità di Riavvio dei dispositivi con firmware aggiornato al nuovo configuratore web</li>
								<li>Corretto riconoscimento del dispositivo DC/IP</li>
								<li>Aggiunta funzione di spegnimento, solo per ETI/SERv3</li>
							</ul>
						</li>
					</ul>
				`;
			}
			default: { // 'en-US'
				return `
					<ul>
						<li><strong>Changes from version 2.2.6</strong></br>
							<ul>
								<li>Correct device detection of devices with firmware updated to the new web configurator
								<li>Correct Reboot function of devices with firmware updated to the new web configurator</li>
								<li>Successful identification of the DC/IP device</li>
								<li>New Power Off function, only for ETI/SERv3</li>
							</ul>
						</li>
					</ul>
				`;
			}
		}
	}

	downloadXTS7IPWiFi703V2() {
		const url = "https://download.cameconnect.net/firmware/intercom/BptCameXTS-7IP-V2_7_0_3.tgz"
		window.open(url);
	}

	// Design
	@HostListener('window:resize')
	onResize() {
		this.screenWidth = window.innerWidth;
		this.screenHeight = window.innerHeight;
	}

	onExtendedMobile(): boolean {
		return StandardPageLayout.onExtendedMobile(this.screenWidth);
	}

	overTablet() {
		return StandardPageLayout.overTablet(this.screenWidth);
	}

	simpleInputTextLayout(classType: string): string {
		return StandardPageLayout.simpleInputTextLayout(classType, this.screenWidth);
	}

	layoutMarginResponsive(): string {
		return StandardPageLayout.layoutMarginResponsive(this.screenWidth);
	}

	customPaddingX(): string {
		return StandardPageLayout.customPaddingX(this.screenWidth);
	}
}
